import React from 'react';
import { DefaultToastContainer } from 'react-toast-notifications';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ToastContainer = (props: any) => <DefaultToastContainer style={{ zIndex: 1051 }} {...props} />;

export default ToastContainer;
